import { MessagesContextValue } from '@/types/message';
import { createContext, useContext } from 'react';

export const MessagesContext = createContext<MessagesContextValue | null>(null);

export const useMessagesContext = () => {
  const ctx = useContext(MessagesContext);
  if (!ctx) {
    throw new Error('useMessagesContext must be used within a MessagesProvider');
  }
  return ctx;
};
